// extracted by mini-css-extract-plugin
module.exports = {"d1xoch4v":"d1xoch4v"};